import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9c2a11de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "compute-step-slider__wrapper" }
const _hoisted_2 = { class: "compute-step-slider__close-label" }
const _hoisted_3 = { class: "compute-step-slider__header" }
const _hoisted_4 = { class: "compute-step-slider__title" }
const _hoisted_5 = { class: "compute-step-slider__tag" }
const _hoisted_6 = {
  key: 0,
  class: "compute-step-slider__subtitle"
}

import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { IonPage, IonContent, IonIcon } from '@ionic/vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import useModal from '@/composables/useModal';
import { useSizeStepStore } from '@/store/sizeStep';
import { Icons } from '@/enums/Icons';
import ComputeWizardSize from '@/components/ComputeWizard/ComputeWizardSize.vue';
import ComputeWizardSurface from '@/components/ComputeWizard/ComputeWizardSurface.vue';
import ComputeWizardFriction from '@/components/ComputeWizard/ComputeWizardFriction.vue';
import ComputeWizardQuality from '@/components/ComputeWizard/ComputeWizardQuality.vue';
import ComputeWizardClamping from '@/components/ComputeWizard/ComputeWizardClamping.vue';
import BaseStepper from '@/components/BaseStepper.vue';
import BaseButton from '@/components/BaseButton.vue';
import NavigationFooter from '@/components/NavigationFooter.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComputeStepSlider',
  props: {
    requestedStep: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const { dismissCurrentModal } = useModal();
const sizeStepStore = useSizeStepStore();

const itself = ref<any>();
const swiperInstance = ref<any>();

const surfaceStepTitle = computed(() =>
  sizeStepStore.selectedObject
    ? t('home.steps.surface.label_with_size_value', { size_value: sizeStepStore.selectedObject.key })
    : t('home.steps.surface.label')
);

const elements = computed(() => [
  { title: t('home.steps.size.label'), component: ComputeWizardSize },
  {
    title: surfaceStepTitle.value,
    subtitle: t('home.steps.surface_subtitle.label'),
    component: ComputeWizardSurface,
  },
  { title: t('home.steps.friction.label'), component: ComputeWizardFriction },
  { title: t('home.steps.quality.label'), component: ComputeWizardQuality },
  { title: t('home.steps.clamping.label'), component: ComputeWizardClamping },
]);

const handleSwiperInit = (swiper: any) => {
  swiperInstance.value = swiper;
};

const handleSlideChange = () => {
  itself.value.scrollTo(0, 0);
};

const updateSwiper = (immediate = false) => {
  let timer = 1000;
  if (immediate) {
    timer = 1;
  }
  const timeout = setTimeout(() => {
    swiperInstance.value.updateAutoHeight();
    clearTimeout(timeout);
  }, timer);
};

const dismiss = async () => {
  await dismissCurrentModal();
};

onMounted(() => {
  updateSwiper(false);

  if (props.requestedStep && props.requestedStep >= 0 && props.requestedStep < elements.value.length) {
    swiperInstance.value.slideTo(props.requestedStep);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { forceOverscroll: false }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "compute-step-slider",
            ref_key: "itself",
            ref: itself
          }, [
            _createVNode(_unref(Swiper), {
              class: "compute-step-slider__swiper",
              direction: "horizontal",
              loop: false,
              "simulate-touch": false,
              "auto-height": "",
              onSwiper: handleSwiperInit,
              onSlideChange: handleSlideChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elements.value, (element, index) => {
                  return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                    class: "compute-step-slider__slide",
                    key: `segment-${index}`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_Transition, { name: "fade" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, [
                            _createVNode(BaseButton, {
                              class: "compute-step-slider__close",
                              color: "light",
                              onClick: dismiss
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), {
                                  class: "compute-step-slider__close-icon",
                                  icon: _unref(Icons).Cross
                                }, null, 8, ["icon"]),
                                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('wizard.close')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(BaseStepper, {
                              class: "compute-step-slider__stepper",
                              total: elements.value.length,
                              current: index + 1
                            }, null, 8, ["total", "current"]),
                            _createElementVNode("p", _hoisted_3, [
                              _createElementVNode("span", _hoisted_4, [
                                _createElementVNode("span", _hoisted_5, _toDisplayString(index + 1), 1),
                                _createTextVNode(" " + _toDisplayString(element.title), 1)
                              ]),
                              (element.subtitle)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(element.subtitle), 1))
                                : _createCommentVNode("", true)
                            ]),
                            (_openBlock(), _createBlock(_resolveDynamicComponent(element.component), {
                              onRequestNextStep: ($event: any) => (index === elements.value.length - 1 ? dismiss() : swiperInstance.value.slideNext())
                            }, null, 40, ["onRequestNextStep"])),
                            _createVNode(NavigationFooter, {
                              "is-first": index === 0,
                              "is-last": index === elements.value.length - 1,
                              onRequestNextStep: ($event: any) => (index === elements.value.length - 1 ? dismiss() : swiperInstance.value.slideNext()),
                              onRequestPreviousStep: _cache[0] || (_cache[0] = ($event: any) => (swiperInstance.value.slidePrev()))
                            }, null, 8, ["is-first", "is-last", "onRequestNextStep"])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ], 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})